var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine2Cup0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41751 8.13222C2.63781 5.71623 2.74796 4.50823 3.30423 3.58545C3.79355 2.77374 4.5164 2.11381 5.36918 1.70022C6.33867 1.23004 7.55167 1.23004 9.97768 1.23004H26.4383C28.8644 1.23004 30.0774 1.23004 30.9611 1.70022C31.7385 2.11381 32.341 2.77374 32.6823 3.58545C33.0702 4.50823 32.9601 5.71623 32.7398 8.13222L31.2451 24.5249C31.0248 26.9409 30.9146 28.1489 30.3583 29.0716C29.869 29.8833 29.1462 30.5433 28.2934 30.9569C27.3239 31.4271 26.1109 31.4271 23.6849 31.4271H7.22423C4.79822 31.4271 3.58521 31.4271 2.70147 30.9569C1.92411 30.5433 1.32161 29.8833 0.980324 29.0716C0.592333 28.1489 0.702482 26.9409 0.922779 24.5249L2.41751 8.13222Z",
    fill: "#DADBF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3646 23.7309L12.6649 20.8431C12.8497 19.1104 13.4735 18.3249 15.0445 16.7539L16.6386 15.1829C17.5396 14.2819 17.7937 13.7736 17.9092 12.4799L18.0479 11.1861C18.1403 10.262 17.6551 10.0079 17.1237 10.0079C16.5693 10.0079 16.1072 10.262 16.0148 11.163L15.8069 13.1961H13.4042L13.6352 11.0013C13.8432 8.96827 15.0676 7.88245 17.2855 7.88245C19.8037 7.88245 20.8664 9.10689 20.6123 11.4172L20.4505 12.9419C20.2657 14.5822 19.873 15.2753 18.3713 16.777L16.5462 18.5559C15.8069 19.2952 15.2755 19.8265 15.16 20.9355L15.0907 21.5823H19.434L19.203 23.7309H12.3646Z",
    fill: "#08080A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine2Cup0);
export default __webpack_public_path__ + "static/media/line-2-cup-0.fbcc643a40963a5fe42c74258420235a.svg";
export { ForwardRef as ReactComponent };